import { render, staticRenderFns } from "./LabelComponent.vue?vue&type=template&id=42aa039f&scoped=true"
import script from "./LabelComponent.vue?vue&type=script&lang=js"
export * from "./LabelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aa039f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42aa039f')) {
      api.createRecord('42aa039f', component.options)
    } else {
      api.reload('42aa039f', component.options)
    }
    module.hot.accept("./LabelComponent.vue?vue&type=template&id=42aa039f&scoped=true", function () {
      api.rerender('42aa039f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/formComponents/LabelComponent.vue"
export default component.exports